"use client";

import { createSafeContext } from "@/common/helpers/react";

export interface FormItemContextValue {
  id: string;
}

export const [FormItemContext, useFormItemContext] = createSafeContext<FormItemContextValue>(
  "useFormField should be used within <FormItem>",
);
